// extracted by mini-css-extract-plugin
export default {"accordianWrapper":"Accordian_accordianWrapper__c49wC","plusMinus":"Accordian_plusMinus__O1Xjo","description":"Accordian_description__S9pUa"};